import { configureStore } from "@reduxjs/toolkit";
import comercialStructureReducer from "./reducers/comercialStructure";
import favoritosMenuReducer from "./reducers/favoritosMenuReducer";

export default configureStore({
  reducer: {
    comercialStructure: comercialStructureReducer,
    favoritosMenu: favoritosMenuReducer
  },
});
